import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upcomingCheckForDatePipe',
    standalone: false
})
export class UpcomingCheckForDatePipe implements PipeTransform {
    transform(dateTime?: any, includeTime?: boolean): any {
        let targetDate = new Date(dateTime);
        const nowDate = new Date();
        if (!includeTime) {
            targetDate.setHours(0, 0, 0, 0);
            nowDate.setHours(0, 0, 0, 0);
        }
        return targetDate > nowDate;
    }
}
